function setRussianErrorMessage(element, signal) {
    if (!element || element.type === 'hidden') return;

    const errorTypeMessages = {
        valueMissing: () => 'Пожалуйста заполните поле',
        typeMismatch: () => {
            if (element.type === 'email') return 'Введите корректный email адрес';
            if (element.type === 'tel') return 'Введите корректный номер телефона';
            return 'Неверный формат данных';
        },
        tooShort: () => `Минимальная длина: ${element.minLength} символов`,
        tooLong: () => `Максимальная длина: ${element.maxLength} символов`,
        patternMismatch: () => 'Неверный формат. Проверьте требования',
        rangeOverflow: () => `Значение не должно превышать ${element.max}`,
        rangeUnderflow: () => `Значение не должно быть меньше ${element.min}`,
        stepMismatch: () => 'Значение не соответствует допустимому шагу',
    };

    const invalidHandler = () => {
        const validity = element.validity;
        const errorKey = Object.keys(errorTypeMessages).find(key => validity[key]);
        const message = errorKey
            ? errorTypeMessages[errorKey]()
            : 'Некорректное значение';
        element.setCustomValidity(message);
    };

    const inputHandler = () => {
        element.setCustomValidity('');
    };

    element.addEventListener('invalid', invalidHandler, { signal });
    element.addEventListener('input', inputHandler, { signal });
}

export default setRussianErrorMessage;
